<template>
  <div id="page-settings-sync">

    <!-- BREADCRUMB SECTION -->
    <vs-row class="mb-5" vs-align="center">
      <vs-col vs-w="12">
        <h2 class="breadcrumb">Εισαγωγή συνδέσμων από Excel</h2>
      </vs-col>
    </vs-row>

    <div class="vx-card p-6">

      <!-- Content Row -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex items-end mb-3">
            <feather-icon icon="UploadIcon" class="mr-2" svgClasses="w-5 h-5"/>
            <h4 class="leading-none font-medium text-primary">Εισαγωγή συνδέσμων</h4>
          </div>
          <p>Για την καταχώρηση των προιόντων παρακαλώ όπως χρησιμοποιηθεί συγκεκριμένη μορφή αρχείου (παρακάτω
            link).</p>
          <a href="/IMPORT_LINKS_TEMPLATE.xlsx" target="_blank">Πρότυπο αρχείο εισαγωγής</a>

          <vs-divider/>

          <div class="vx-row mt-6 excel-import">
            <div class="vx-col w-full">
              <input type="file" ref="fileInput" class="hidden" accept=".xlsx, .xls"
                     @change="handleClick">
              <div
                  @click="$refs.fileInput.click()"
                  @drop="handleDrop"
                  @dragover="handleDragover"
                  @dragenter="handleDragover"
                  class="px-8 py-16 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl">
                <feather-icon icon="UploadCloudIcon" svgClasses="h-16 w-16 stroke-current text-grey"
                              class="block"/>
                <span>Αποθέστε το αρχείο ή κάντε </span>
                <span class="font-medium text-primary"
                      @click.stop="$refs.fileInput.click()">Αναζήτηση</span>
                <!-- <vs-button type="border" @click.stop="$refs.fileInput.click()">Browse</vs-button> -->
              </div>

              <vx-card v-if="tableData.length && header.length">
                <vs-table stripe pagination :max-items="10" search :data="tableData">
                  <template slot="header">
                    <h4>{{ sheetName }}</h4>
                  </template>

                  <template slot="thead">
                    <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :key="heading" v-for="heading in header">
                        {{ data[indextr][heading] }}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vx-card>
            </div>
          </div>

        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <div class="vx-row">
              <div class="vx-col pt-2">
                <p>Αν θέλετε να γίνει αυτόματη εισαγωγή των συνδέσμων για τα προϊόντα που δε έχουν πατήστε <a href="#" @click="findSkroutzUrls()">εδώ</a></p>
              </div>
            </div>
            <vs-button class="ml-auto mt-2" @click="openConfirm()">Εισαγωγή συνδέσμων</vs-button>
          </div>
        </div>
      </div>
    </div>

    <!-- start::confirmation popup -->
    <vs-popup class="holamundo" title="Επιλογή εργασίες εισαγωγής" :active="displayPopUp" @close="closePopUp">

      <!-- start::pop up content -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <p>
            Επιλέξτε μια από τις παρακάτω επιλογές:<br><br>
          </p>
          <p>
            Με την πρώτη επιλογή θα γίνει εισαγωγή συνδέσμων <b>διαγράφοντας</b> όλων των προηγούμενων συνδέσμων που υπάρχουν στα προϊόντα.<br><br>
          </p>
          <hr>
          <p>
            <br>Με τη δεύτερη επιλογή θα προστεθούν νέοι σύνδεσμοι χωρίς την αφαίρεση των προηγούμενων.
          </p>
        </div>
      </div>
      <!-- start::pop up content -->

      <!-- start::pop up actions -->
      <div class="vx-row">
        <div class="vx-col w-1/2">
          <div class="mt-8 flex flex-wrap items-center">
            <vs-button class="mt-8 flex flex-wrap items-center" @click.prevent="deleteAndCreate">
              1. Διαγραφή και επαναεισαγωγή συνδέσμων
            </vs-button>
          </div>
        </div>
        <div class="vx-col w-1/2">
          <div class="mt-8 flex flex-wrap items-center">
            <vs-button class="mt-8 flex flex-wrap items-center" @click.prevent="doNotDeleteUpdate">
              2. Ενημέρωση υπαρχόντων συνδέσμων με νέους
            </vs-button>
          </div>
        </div>
      </div>
      <!-- end::pop up actions -->

    </vs-popup>
    <!-- start::confirmation popup -->
  </div>
</template>

<script>
import vSelect from 'vue-select'
import XLSX from 'xlsx'
import axios from '@/axios.js'

export default {
  props: {},
  components: {
    vSelect,
  },
  data() {
    return {
      tableData: [],
      header: [],
      sheetName: '',
      item: {
        "file": null
      },
      xfilename: '',
      apiEndpoint: localStorage.getItem('apiEndpoint'),
      token: localStorage.getItem('accessToken'),
      initiated: false,
      initiatedSync: false,
      excelData: {
        header: null,
        results: null,
        meta: null
      },
      displayPopUp: false
    }
  },
  watch: {},
  methods: {
    findSkroutzUrls() {
      let vm = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Επιβεβαίωση`,
        text: 'Με την κίνηση αυτή θα ξεκινήσει η διαδικασία εύρεσης συνδέσμων για όλα τα προϊόντα. Είστε σίγουρος;',
        acceptText: 'Εύρεση',
        cancelText: 'Ακύρωση',
        accept: this.findSkroutzUrlsAction
      })
    },
    findSkroutzUrlsAction() {
      let vm = this;
      axios.defaults.baseURL = vm.apiEndpoint;
      axios.defaults.headers.common = {'Authorization': `bearer ${vm.token}`}
      axios.get('jobs/find-skroutz-links')
      vm.$vs.notify({
        color: 'success',
        title: 'Ξεκίνησε η διαδικασία',
        position: 'top-right',
        text: 'Η διαδικασία έχει ξεκινήσει και θα λάβετε ενημέρωση μέσω email μόλις ολοκληρωθεί.'
      });
    },
    closePopUp() {
      this.displayPopUp = false
    },
    readerData(rawFile) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, {type: 'array'})
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const header = this.getHeaderRow(worksheet)
          const results = XLSX.utils.sheet_to_json(worksheet)
          const meta = {sheetName: firstSheetName}
          this.generateData({header, results, meta})
          this.loadDataInTable({header, results, meta})
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C = undefined
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({c: C, r: R})]
        /* find the cell in the first row */
        let hdr = `UNKNOWN ${C}` // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    generateData({header, results, meta}) {
      this.excelData.header = header
      this.excelData.results = results
      this.excelData.meta = meta
      if (this.onSuccess) this.onSuccess(this.excelData)
    },
    loadDataInTable({results, header, meta}) {
      this.header = header
      this.tableData = results
      this.sheetName = meta.sheetName
    },
    handleDragover(e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDrop(e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only support uploading one file!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return
      }
      const rawFile = files[0] // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only supports upload .xlsx, .xls, .csv suffix files',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.uploadFile(rawFile)
    },
    handleClick(e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      // console.log(rawFile);
      this.uploadFile(rawFile)
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
    uploadFile(file) {
      this.$refs['fileInput'].value = null // fix can't select the same excel
      this.item.file = file;
      this.xfilename = this.item.file.name;

      this.readerData(file)
    },
    doNotDeleteUpdate() {
      this.saveSettings('update')
    },
    deleteAndCreate() {
      this.saveSettings('delete')
    },
    openConfirm() {
     this.displayPopUp = true
    },
    saveSettings(action) {
      {
        let vm = this;
        const formData = new FormData();
        vm.$vs.loading();
        formData.append('file', vm.item.file);
        formData.append('action', action);
        axios.defaults.baseURL = vm.apiEndpoint;
        axios.defaults.headers.common = {'Authorization': `bearer ${vm.token}`}
        axios.post("xmlOptions/uploadskroutzlinks", formData)
            .then((response) => {
              vm.$vs.loading.close();
              vm.initiated = false;
              vm.$vs.notify({
                color: 'success',
                title: 'Οι σύνδεσμοι προστέθηκαν με επιτυχία',
                position: 'top-right',
                text: response.data.message //'The selected source configuration was successfully saved and new products have been parsed.'
              })
              this.displayPopUp = false
              this.tableData = []
            })
            .catch((error) => {
              vm.$vs.loading.close();
              vm.$vs.notify({
                color: 'warning',
                title: 'Οι αλλαγές δεν αποθηκεύτικαν με επιτυχία',
                position: 'top-right',
                text: 'Παρουσιάστηκε κάποιο σφάλμα και δεν ήταν δυνατή η ανάλυση της πηγής. Ελέγξτε ότι όλα τα πεδία έχουν ρυθμιστεί σωστά με επικεφαλίδες.'
              })
            })
      }
    }
  },
  mounted() {
    let vm = this;
  }
}
</script>

<style scoped>
.vs-button-primary.vs-button-flat {
  font-size: 9px;
  padding: 5px !important;
}
</style>
